<template>
  <div>
    <div class="row wrapper border-bottom white-bg page-heading">
      <div class="col-xs-9">
        <h2>Export Registrations</h2>
        <ol class="breadcrumb">
          <li>You may export previous registrations in this page.</li>
        </ol>
      </div>
    </div>
    <div class="wrapper wrapper-content">
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Search Registrations</h5>
              <div class="ibox-tools">
                <a class="collapse-link">
                  <i class="fa fa-chevron-up" />
                </a>
              </div>
            </div>
            <div class="ibox-content">
              <div class="ibox-content">
                <div class="row m-b-xs">
                  <div class="col-md-10">
                    <div class="form-inline">
                      <div class="input-daterange input-group col-sm-12">
                        <span class="input-group-addon">
                          <span class="glyphicon glyphicon-time" />
                        </span>
                        <input
                               id="timespan"
                               type="text"
                               class="input-sm form-control"
                               name="timespan"
                               required
                               placeholder="Choose event date range">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <button
                            class="btn btn-primary"
                            style="width:100%"
                            @click="onClickFetch()">Fetch</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row animated fadeInDown">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-title">
              <h5>Registrations</h5>
              <div class="ibox-tools">
                <button
                        class="btn btn-primary btn-xs"
                        @click="downloadRegistrations">Download as Excel</button>
              </div>
            </div>
            <div class="ibox-content">
              <div class="row">
                <div class="col-sm-3 col-sm-offset-6">
                  <div class="form-group">
                    <label
                           class="m-r-sm"
                           style="max-width:50%;">Item per page</label>
                    <select
                            v-model="perPageInput"
                            class="form-control"
                            style="max-width:50%;display: inline-flex;">
                      <option value="1">1</option>
                      <option value="10">10</option>
                      <option value="15">15</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-3">
                  <vuetable-pagination
                                       ref="pagination"
                                       :css="paginationcss"
                                       @vuetable-pagination:change-page="onChangePage" />
                </div>
              </div>
              <vuetable
                        ref="vuetable"
                        :fields="fields"
                        :data="onScreenRegistrationArray"
                        :css="tablecss"
                        :api-mode="false"
                        pagination-path="pagination" />
              <div class="vuetable-pagination">
                <vuetable-pagination-info ref="paginationInfo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import "@/assets/inspinia/font-awesome/css/font-awesome.css";
import Datepicker from "vuejs-datepicker";
import XLSX from "xlsx";
import Vuetable from "vuetable-2/src/components/Vuetable";
import Vue from "vue";
import VueEvents from "vue-events";
import VuetablePagination from "./VuetablePaginationDropdownCustom.vue";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
Vue.use(VueEvents);

const OrderStatus = {
  0: '已加入 / Join',
  1: '等候列表 / Waiting List',
  2: '正常取消 / Cancelled',
  3: '黑名单取消 / Cancelled (Blacklist)',
  4: '活动已取消 / Activity Canclled'
}

export default {
  name: "ExportRegistrations",
  components: {
    Datepicker,
    Vuetable,
    vueevents: VueEvents,
    VuetablePagination,
    VuetablePaginationInfo
  },
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    id: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      registrationArray: [],
      transformedRegistrationArray: [],
      onScreenRegistrationArray: [],
      fields: [
        {
          name: "Student No"
        },
        {
          name: "Name",
        },
        {
          name: "School",
        },
        {
          name: "Year"
        },
        {
          name: "Activity"
        },
        {
          name: "Start Time"
        },
        {
          name: "End Time"
        },
        {
          name: "Registration Status"
        },
        {
          name: "Sign-In Status"
        }
      ],
      tablecss: {
        tableClass:
          "table table-responsive table-striped table-bordered table-hover signed-users-list",
        titleClass: "title-class"
      },
      paginationcss: {
        wrapperClass: "btn-group pull-right",
        icons: {
          prev: "fa fa-chevron-left",
          next: "fa fa-chevron-right"
        },
        linkClass: "btn btn-default",
        dropdownClass: "btn btn-default dropdown-toggle",
        pageClass: "dropdown-menu",
        disabledClass: "btn-disabled"
      },
      perPageInput: "10",
      outFile: "",
      fromDate: "",
      endDate: ""
    };
  },
  watch: {
    perPageInput (newVal, oldVal) {
      this.perPageInput = newVal;
      this.onScreenRegistrationArray = this.transformRegistration(
        this.transformedRegistrationArray,
        1
      );
      this.onPaginationData(this.onScreenRegistrationArray.pagination);
    }
  },
  mounted () {
    this.outFile = document.createElement("a");

    $('#timespan').daterangepicker({
      "showDropdowns": true,
      "maxSpan": {
        "months": 1
      },
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last 7 Days': [moment().subtract(6, 'days'), moment()],
        'Last 30 Days': [moment().subtract(29, 'days'), moment()],
        'This Month': [moment().startOf('month'), moment().endOf('month')],
        'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
      },
      "alwaysShowCalendars": true,
      "startDate": moment().subtract(1, 'month').startOf('month'),
      "endDate": moment().subtract(1, 'month').endOf('month'),
      "maxDate": moment()
    })
    // }, function (start, end, label) {
    //   console.log('New date range selected: ' + start.format('YYYY-MM-DD') + ' to ' + end.format('YYYY-MM-DD') + ' (predefined range: ' + label + ')');
    // });
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    transformRegistration (data, currentPage) {
      const that = this;
      let perPage = parseInt(that.perPageInput);
      let startIndex = (currentPage - 1) * perPage;
      let endIndex = currentPage * perPage;
      if (endIndex > data.length) {
        endIndex = data.length;
      }

      let transformed = {};
      transformed.data = data.slice(startIndex, endIndex);

      transformed.pagination = {
        total: data.length,
        per_page: perPage,
        current_page: currentPage,
        last_page: Math.ceil(data.length / perPage),
        from: 1,
        to: Math.ceil(data.length / perPage),
        prev: currentPage - 1,
        next: currentPage + 1
      };

      return transformed;
    },
    onChangePage (page) {
      if (page < 1 || page > this.onScreenRegistrationArray.pagination.last_page) {
        return;
      }
      this.onScreenRegistrationArray = this.transformRegistration(
        this.transformedRegistrationArray,
        page
      );
      this.onPaginationData(this.onScreenRegistrationArray.pagination);
    },
    onClickFetch () {
      const from_date = $("#timespan")
        .data("daterangepicker")
        .startDate.format('YYYY-MM-DD')
      const to_date = $("#timespan")
        .data("daterangepicker")
        .endDate.format('YYYY-MM-DD')
      this.fetchRegistrations(from_date, to_date)
      this.fromDate = from_date
      this.endDate = to_date
    },
    fetchRegistrations (from_date, to_date) {
      const that = this;

      window.request
        .get(`registration/${from_date}/${to_date}/`)
        .then(response => {
          if (response.data.orders) {
            that.registrationArray = response.data.orders.sort(function (a, b) {
              var aEventTime = a.event.start_time;
              var bEventTime = b.event.start_time;
              var aOrderTime = a.order_time;
              var bOrderTime = b.order_time;

              if (aEventTime == bEventTime) {
                return (aOrderTime < bOrderTime) ? -1 : (aOrderTime > bOrderTime) ? 1 : 0;
              }
              else {
                return (aEventTime < bEventTime) ? -1 : 1;
              }

            })
            that.transformedRegistrationArray = [];
            that.registrationArray.forEach((current) => {
              that.transformedRegistrationArray.push({
                "Student ID": current.user.ldap_id,
                "Name": current.user.name,
                "Student Email": current.user.email,
                "School": current.user.extra_info ? current.user.extra_info.school : "",
                "Year": current.user.extra_info ? current.user.extra_info.attend_year : "",
                "Activity": current.event.name,
                "Start Time": moment.unix(current.event.start_time).format("YYYY-MM-DD HH:mm:ss"),
                "End Time": moment.unix(current.event.end_time).format("YYYY-MM-DD HH:mm:ss"),
                "Registration Status": OrderStatus[current.order_status],
                "Sign-In Status": current.sign_in_status ? "Yes" : "No"
              });
            })
          }
        })
        .finally(() => {
          that.onScreenRegistrationArray = that.transformRegistration(
            that.transformedRegistrationArray,
            1
          );
          that.onPaginationData(that.onScreenRegistrationArray.pagination);

          that.$emit("hideLoading");
        });
    },
    downloadRegistrations () {
      this.downloadExl(this.transformedRegistrationArray, `Registrations_${this.fromDate}_${this.endDate}`);
    },
    downloadExl (data, downName) {
      var workbook = XLSX.utils.book_new();

      var ws = XLSX.utils.json_to_sheet(data);
      XLSX.utils.book_append_sheet(workbook, ws, "Results");
      XLSX.writeFile(workbook, downName + '.xlsx', { type: 'file' });
    },
    s2ab (s) {
      // 字符串转字符流
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xff;
      }
      return buf;
    }
  }
};
</script>

<style>
</style>

<style scoped>
@media (max-width: 426px) {
  .mobile-hide {
    display: none;
  }
}
@media (min-width: 426px) {
  .mobile-show {
    display: none;
  }
}

#add_blacklist {
  padding: 2% 1% 0 10%;
}

#add_blacklist-mobile {
  padding: 20px 1% 0 0;
}
</style>
